import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import Banner from './components/Banner';
import Stories from './components/Stories';
import Challenges from './components/Challenges';
import Contact from './components/Contact';
import Partner from './components/Partner';
import Sustainability from './components/Sustainability';

export default function PowerForAll() {
    const { t } = useLang('PowerForAll');
    const { locale } = getLocal();

    return (
        <div className={`${styles.PowerForAll} GtmModuleData-section`}>
            <Banner />
            <Stories />
            {locale === 'global' && <Sustainability />}
            <Partner />
            <Challenges />
            <Contact />
        </div>
    );
}
